module.exports = __webpack_public_path__ + "assets/img/profile-header.b8d580da.jpg";